import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { LoaderService, Loader } from '../common/loader/loader.service';
import { TokenService } from '../token/token.service';

@Injectable()
export class LoginService {
  constructor(private sessionStorage: SessionStorageService, private tokenService: TokenService, private loaderService: LoaderService, private router: Router) { }

  goToLoginUrl(isSignup: boolean) {
    this.tokenService.removeAllToasts();
    this.tokenService.removeAllModals();
    this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    this.router.navigate(['/authentication'], { queryParams: { isSignup: isSignup.toString() } });
  }
  goToLoginUrlWithUtmParams(isSignup: boolean, utm_source: string, utm_medium: string, utm_campaign: string) {
    this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    this.router.navigate(['/authentication'], { queryParams: { isSignup: isSignup, utm_source, utm_medium, utm_campaign } });
  }
  getMerchantId() {
    return this.sessionStorage.retrieve('zest-application') ? this.sessionStorage.retrieve('zest-application').MerchantId as string : null;
  }
  getApplicationId() {
    return this.sessionStorage.retrieve('zest-application') ? this.sessionStorage.retrieve('zest-application').ApplicationId as string : null;
  }
  randomString(length: number) {
    let result = '';
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  }
  inIframe() {
      try {
        return ((window.self !== window.top));
    } catch (e) {
        return true;
    }
  }
}
